
import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'
import { createWarehouse } from './warehouses'
import { hideWarehouseSetup } from 'actions'

/**
 * Types.
 */

export const WAREHOUSE_SETUP_SELECT_DATABASE = 'WAREHOUSE_SETUP_SELECT_DATABASE'
export const WAREHOUSE_SETUP_SELECT_CONNECT_TAB = 'WAREHOUSE_SETUP_SELECT_CONNECT_TAB'
export const WAREHOUSE_SETUP_ENTER_USERNAME = 'WAREHOUSE_SETUP_ENTER_USERNAME'
export const WAREHOUSE_SETUP_ENTER_PASSWORD = 'WAREHOUSE_SETUP_ENTER_PASSWORD'
export const WAREHOUSE_SETUP_ENTER_HOST = 'WAREHOUSE_SETUP_ENTER_HOST'
export const WAREHOUSE_SETUP_ENTER_PORT = 'WAREHOUSE_SETUP_ENTER_PORT'
export const WAREHOUSE_SETUP_ENTER_DATABASE = 'WAREHOUSE_SETUP_ENTER_DATABASE'
export const WAREHOUSE_SETUP_ENTER_PROJECT_ID = 'WAREHOUSE_SETUP_ENTER_PROJECT_ID'
export const WAREHOUSE_SETUP_ENTER_DATASET_ID = 'WAREHOUSE_SETUP_ENTER_DATASET_ID'
export const WAREHOUSE_SETUP_CONNECT = 'WAREHOUSE_SETUP_CONNECT'
export const WAREHOUSE_SETUP_CONNECT_ERROR = 'WAREHOUSE_SETUP_CONNECT_ERROR'
export const WAREHOUSE_SETUP_CONNECTED = 'WAREHOUSE_SETUP_CONNECTED'
export const WAREHOUSE_SETUP_COMPLETED = 'WAREHOUSE_SETUP_COMPLETED'
export const WAREHOUSE_SETUP_CANCELED = 'WAREHOUSE_SETUP_CANCELED'
export const WAREHOUSE_SETUP_RETRY = 'WAREHOUSE_SETUP_RETRY'
export const WAREHOUSE_SETUP_EDIT_CREDENTIALS = 'WAREHOUSE_SETUP_EDIT_CREDENTIALS'
export const WAREHOUSE_SETUP_CHANGE_STEP = 'WAREHOUSE_SETUP_CHANGE_STEP'

/**
 * Actions.
 */

export const warehouseSetupSelectDatabase = createAction(WAREHOUSE_SETUP_SELECT_DATABASE)
export const warehouseSetupSelectConnectTab = createAction(WAREHOUSE_SETUP_SELECT_CONNECT_TAB)
export const warehouseSetupEnterUsername = createAction(WAREHOUSE_SETUP_ENTER_USERNAME)
export const warehouseSetupEnterPassword = createAction(WAREHOUSE_SETUP_ENTER_PASSWORD)
export const warehouseSetupEnterHost = createAction(WAREHOUSE_SETUP_ENTER_HOST)
export const warehouseSetupEnterPort = createAction(WAREHOUSE_SETUP_ENTER_PORT)
export const warehouseSetupEnterDatabase = createAction(WAREHOUSE_SETUP_ENTER_DATABASE)
export const warehouseSetupEnterProjectId = createAction(WAREHOUSE_SETUP_ENTER_PROJECT_ID)
export const warehouseSetupCompleted = createAction(WAREHOUSE_SETUP_COMPLETED)
export const warehouseSetupEditCredentials = createAction(WAREHOUSE_SETUP_EDIT_CREDENTIALS)
export const warehouseSetupChangeStep = createAction(WAREHOUSE_SETUP_CHANGE_STEP)

const warehouseSetupCanceled = createAction(WAREHOUSE_SETUP_CANCELED)
const warehouseSetupConnect = createAction(WAREHOUSE_SETUP_CONNECT)
const warehouseSetupConnectError = createAction(WAREHOUSE_SETUP_CONNECT_ERROR)
const warehouseSetupConnected = createAction(WAREHOUSE_SETUP_CONNECTED)

export function warehouseSetupSubmitConnectForm ({ workspaceSlug, databaseId, data }) {
  return function (dispatch) {
    dispatch(warehouseSetupConnect(data))
    fetch(`/api/workspaces/${workspaceSlug}/warehouses/connect/${databaseId}`, {
      method: 'POST',
      body: JSON.stringify(data)
    })
    .then(res => {
      if (res.ok) {
        dispatch(warehouseSetupConnected())
        dispatch(createWarehouse({ workspaceSlug, databaseId, settings: data }))
      } else {
        res.json().then(body => {
          dispatch(warehouseSetupConnectError(body))
        })
      }
    })
    .catch(err => {
      const error = getConnectionError(err)
      dispatch(warehouseSetupConnectError(error))
    })
  }
}

export const warehouseSetupRetry = workspaceSlug => (dispatch, getState) => {
  dispatch({ type: WAREHOUSE_SETUP_RETRY })
  const state = getState()
  const { settings, databaseId } = state.application.warehouseSetup
  dispatch(warehouseSetupSubmitConnectForm({ data: settings, workspaceSlug, databaseId }))
}

function getConnectionError (err, res) {
  if (err) {
    return err
  }

  if (res.body) {
    return res.body
  }

  return {
    code: res.status,
    error: res.text
  }
}

export function cancelWarehouseSetup () {
  return (dispatch) => {
    dispatch(hideWarehouseSetup())
    dispatch(warehouseSetupCanceled())
  }
}



// WEBPACK FOOTER //
// ./actions/warehouse-setup.js